import * as yup from 'yup'

export const emailWebhookDataSchema = yup.object({
  userId: yup.string().required(),
  data: yup.object({
    messageId: yup.string().optional(),
    threadId: yup.string().optional(),
    from: yup.string(),
    to: yup.array().of(yup.string()),
    cc: yup.array().of(yup.string()),
    bcc: yup.array().of(yup.string()),
    subject: yup.string(),
    message: yup.string(),
    attachments: yup.array().of(yup.string().required()),
    // One entry per retained attachment, in the same order as `attachments`. Carries the facts a
    // consumer needs to route a document without re-reading it.
    attachmentDetails: yup
      .array()
      .of(
        yup
          .object({
            documentId: yup.string().required(),
            fileName: yup.string().required(),
            mimeType: yup.string().required(),
            sizeBytes: yup.number().required(),
            sha256: yup.string().required(),
          })
          .required(),
      )
      .optional(),
    receivedAt: yup.string().optional(),
    emlFileId: yup.string().optional(),
  }),
  customData: yup.object({
    customDossScalar: yup.string().notRequired(),
    // FirstBase: Array of extracted numbers we think may be PO #s
    customDossArray: yup
      .array()
      .of(yup.object({ customDossObjectScalar: yup.string().notRequired() }).notRequired()),
  }),
})

/**
 * The data that has been parsed from an Outlook webhook.
 */
export type EmailWebhookData = yup.InferType<typeof emailWebhookDataSchema>
